export enum GridType {
	NORMAL, SMALL
}

import { Component, ViewChild, ElementRef } from '@angular/core';

@Component({
	selector: 'grid-visual',
	templateUrl: './grid-visual.component.html',
	styleUrls: ['./grid-visual.component.scss'],
})

// ******* this Component draws a grid within a div using SVG - TODO move to shared component
export class GridVisualComponent {
	@ViewChild('canvas') canvas: ElementRef;

	private ctx: CanvasRenderingContext2D;

	constructor(private el: ElementRef) {
	}

	public drawGrid(w: number, h: number, type: GridType = GridType.SMALL) {
		this.ctx = this.canvas.nativeElement.getContext('2d');
		this.ctx.canvas.width = this.el.nativeElement.offsetWidth;
		this.ctx.canvas.height = this.el.nativeElement.offsetHeight;

		const data = `<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
			<defs>
				<pattern id="smallGrid" width="${w}" height="${h}" patternUnits="userSpaceOnUse">
					<path d="M ${w} 0 L 0 0 0 ${h}" fill="none" stroke="whitesmoke" stroke-width="0.5" />
				</pattern>
				<pattern id="grid" width="${w * 10}" height="${h * 10}" patternUnits="userSpaceOnUse">
					<rect width="${w * 10}" height="${h * 10}" fill="url(#smallGrid)" />
					<path d="M ${w * 10} 0 L 0 0 0 ${h * 10}" fill="none" stroke="whitesmoke" stroke-width="1" />
				</pattern>
			</defs>
			<rect width="100%" height="100%" fill="url(#${this.getGridType(type)})" />
		</svg>`;

		const img: any = new Image();
		const svg = new Blob([data], { type: 'image/svg+xml;charset=utf-8' });
		const url = URL.createObjectURL(svg);

		img.onload = () => {
			this.ctx.drawImage(img, 0, 0);
		};
		img.src = url;
	}

	private getGridType(type: GridType): string {
		return (type === GridType.NORMAL) ? 'grid' : 'smallGrid';
	}
}
